import { AsYouType, isValidNumber } from 'libphonenumber-js';

export function validatePhoneNumber(phoneNumber: string) {
  if (!isValidNumber(phoneNumber, 'US')) {
    return 'Please enter a valid phone number.';
  }
  return null;
}

export function formatPhoneNumber(phoneNumber: string) {
  const formatedNumber = new AsYouType('US').input(phoneNumber);
  const value = formatedNumber.endsWith(')')
    ? formatedNumber.slice(0, -1)
    : formatedNumber;
  return value;
}
